import { computed, ref } from 'vue'

import type { Ref, ComputedRef } from 'vue'
import type { MultiselectSearchOption } from '@shared/ui/fields'

import { useListsStore } from '@shared/model'

interface FilterPriorityOptions {
  initial: string[]
}

interface FilterPriorityReturn {
  options: ComputedRef<MultiselectSearchOption[]>
  query: Ref<string[]>
  initialValue: ComputedRef<string[]>
  handleSelected: (selected: MultiselectSearchOption[]) => void
}

export const useFilterPriority = ({ initial }: FilterPriorityOptions): FilterPriorityReturn => {
  const listsStore = useListsStore()

  const query = ref<string[]>(initial)

  const options = computed<MultiselectSearchOption[]>(() => {
    const priorities = listsStore.getTasksKanbanList?.priority ?? {}

    return Object.entries(priorities).map(([key, text]) => ({
      id: key,
      value: key,
      text,
      selected: query.value.includes(key),
    }))
  })

  const initialValue = computed<string[]>(() => {
    return options.value
      .filter(option => option.selected)
      .map(option => option.text)
  })

  const handleSelected = (selected: MultiselectSearchOption[]): void => {
    const isAll = selected.length === options.value.length
    query.value = isAll ? [] : selected.map(option => String(option.value))
  }

  return {
    options,
    query,
    initialValue,
    handleSelected,
  }
}
